import { inPeriod } from '@trg/utils';
import type { FooterData } from './footer-api.type';

export function selectAboutTLW(data?: FooterData) {
  const aboutTLW = data?.aboutTLW?.layoutData?.text ?? [];
  return aboutTLW.filter(inPeriod);
}

export function selectCustomerService(data?: FooterData) {
  const customService = data?.customerService?.layoutData?.text ?? [];
  return customService.filter(inPeriod);
}

export function selectClause(data?: FooterData) {
  const clause = data?.clause?.layoutData?.text ?? [];
  return clause.filter(inPeriod);
}

export function selectAppStore(data?: FooterData) {
  const appStore = data?.appStore?.layoutData?.banner ?? [];
  return appStore.filter(inPeriod);
}
